import {SegmentedControl} from '@mantine/core';
import {ProfileBox} from '../ProfileBox';
import {MiniMenu} from './MiniMenu';
import {NAVIGATION_MENU, NAV_VALUE, type NavValueType} from './constants';

type Props = {
  navValue: NavValueType;
  setNavValue?: (value: NavValueType) => void;
  handleOpenModal?: () => void;
};

export const NavigationForSP: React.FC<Props> = ({
  navValue,
  setNavValue,
  handleOpenModal,
}) => {
  const segmentMenu = NAVIGATION_MENU.map((menu) => ({
    label: menu.name,
    value: menu.value,
  }));

  const currentMenu = NAVIGATION_MENU.find((menu) => menu.value === navValue);

  return (
    <div className="flex flex-col justify-center gap-16">
      <div className="w-full bg-white p-16 rounded-16 text-center">
        <SegmentedControl
          data={segmentMenu}
          value={navValue}
          onChange={(value: NavValueType) => {
            if (
              value === NAV_VALUE.MY_PAGE &&
              !setNavValue &&
              handleOpenModal
            ) {
              handleOpenModal();
            } else if (setNavValue) {
              setNavValue(value);
            }
            if (value === NAV_VALUE.MY_PAGE) {
              location.href = '/mypage';
            }
            if (value === NAV_VALUE.RECOMMEND) {
              location.href = '/';
            }
          }}
          fullWidth
          styles={{
            label: {
              fontWeight: 'bold',
            },
          }}
        />
      </div>
      {navValue === NAV_VALUE.MY_PAGE && <ProfileBox />}
      {currentMenu && <MiniMenu menu={currentMenu.items} />}
    </div>
  );
};
